import React, {Component} from 'react';
import './appBtn.scss';
import {connect} from 'react-redux';
import {refresh_admin} from './../../redux/models/admin';

@connect(
  state => ({admin: state.admin}),
  {refresh_admin}
)

class AppBtn extends Component {
  constructor(props) {
    super(props);
    this.state = {};

  }

  componentWillMount() {

  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  render() {

    return (
      <div className="open-app" style={this.props.style} onClick={this.openApp}>{this.props.text}</div>
    );
  }

  openApp=()=> {
    const {name,uuid} = this.props
    var download_url = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.foundao.bjnews'
    var ios_url = 'com.foundaoBeijingNewsApp://'
    var android_url = 'com.foundao.bjnews://bjnews.com/action?'
    const iosUrl = ios_url + name + '/' + uuid
    const androidUrl = android_url + 'name='+ name + '&uuid='+ uuid
    this.openAppInWeixin(iosUrl,androidUrl)

    // if(this._isWeiXin() || this._isWeiBo() || this._isQQ()){   //判断是否是在微信中打开
    //   this.openAppInWeixin(iosUrl,androidUrl)
    // }else {
    //   var userAgent = this.userAgent()
    //   if( userAgent === 0){   //ios环境
    //     window.location.href = iosUrl
    //     setTimeout(function () {
    //       window.location.href = download_url
    //     },1500)
    //   } else if ( userAgent === 1){  // 安卓环境
    //     window.location.href = androidUrl
    //     var last = Date.now()
    //     //程序切换到后台，计时器会被推迟
    //     setTimeout(function () {
    //       if (Date.now() - last <= 1500) {
    //         //唤起失败，进入下载页
    //         window.location.href = download_url;
    //       }
    //     }, 1500)
    //   }
    // }
  }
  // 唤起app的微信流程,微信中无法直接呼起app，安卓需要通过应用宝流程
  openAppInWeixin =(iosUrl,androidUrl)=> {
    const {name,uuid} = this.props
    window.location.href = `https://cdn.bjnews.com.cn/h5/jumpTemp.html?name=${name}&uuid=${uuid}`

    // var userAgent = this.userAgent();
    // if (userAgent === 0) {   // ios
    //   // ios在微信中需要右上角通过浏览器打开
    //   // this.open_wxShow();
    //   window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.foundao.bjnews&android_schema=' + encodeURIComponent(iosUrl);
    // } else if (userAgent === 1) { // 安卓 通过应用宝
    //   // window.location.href = download_url
    //   // this.open_wxShow();
    //   window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.foundao.bjnews&android_schema=' + encodeURIComponent(androidUrl);
    // }
  };

  // 判断是安卓还是苹果
  userAgent = () => {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      return 0;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      return 1;
    }
  };
  // 判断链接是不是在微信中打开
  _isWeiXin = () => {
    return /micromessenger/.test(navigator.userAgent.toLowerCase());
  };
  // 判断链接是不是在微博中打开
  _isWeiBo = () => {
    return navigator.userAgent.toLowerCase().match(/WeiBo/i) == "weibo"
  };
  // 判断链接是不是在qq中打开
  _isQQ = () => {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/qq/i) == "qq" && ua.match(/MicroMessenger/i) != "micromessenger") {
      return true;
    } else {
      return false;
    }
  };
}

export default AppBtn;


// WEBPACK FOOTER //
// ./src/components/AppBtn/appBtn.js